var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2561_13959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2561_13959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM14 16.75C14.2125 16.75 14.3906 16.6781 14.5343 16.5343C14.6781 16.3904 14.75 16.2122 14.75 15.9998C14.75 15.7871 14.6781 15.609 14.5343 15.4655C14.3906 15.3218 14.2125 15.25 14 15.25H10.75V13.0577C10.75 12.9679 10.7788 12.8942 10.8365 12.8365C10.8942 12.7788 10.9679 12.75 11.0577 12.75H12.9423C13.4474 12.75 13.875 12.575 14.225 12.225C14.575 11.875 14.75 11.4474 14.75 10.9423V9.05775C14.75 8.55258 14.575 8.125 14.225 7.775C13.875 7.425 13.4474 7.25 12.9423 7.25H10C9.7875 7.25 9.60942 7.32192 9.46575 7.46575C9.32192 7.60958 9.25 7.78775 9.25 8.00025C9.25 8.21292 9.32192 8.391 9.46575 8.5345C9.60942 8.67817 9.7875 8.75 10 8.75H12.9423C13.0321 8.75 13.1058 8.77883 13.1635 8.8365C13.2212 8.89417 13.25 8.96792 13.25 9.05775V10.9423C13.25 11.0321 13.2212 11.1058 13.1635 11.1635C13.1058 11.2212 13.0321 11.25 12.9423 11.25H11.0577C10.5526 11.25 10.125 11.425 9.775 11.775C9.425 12.125 9.25 12.5526 9.25 13.0577V15.8462C9.25 16.1022 9.33658 16.3169 9.50975 16.4902C9.68308 16.6634 9.89775 16.75 10.1537 16.75H14Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/Number-2.fb30d92c5f70cf1382a28e6970fa56b2.svg";
export { ForwardRef as ReactComponent };